import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
} from './common.js';

export function createEmbeddedScriptFolderValidation(projectFolder: string) {
  return composeValidations([
    [
      pathAvailableValidation(projectFolder),
      'The script folder must be unique. Select a name that has not been used yet in your application.',
    ],
    [
      pathValidation,
      'The script folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
